import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

class CustomHeading extends PureComponent {
  static defaultProps = {
    body: '',
    headingProps: {},
  };
  static propTypes = {
    body: PropTypes.node,
    headingProps: PropTypes.shape({}),
    // tagName: PropTypes.string.isRequired,
  };

  render() {
    const { body, headingProps } = this.props;
    // const HeadingTag = this.props.tagName;
    // return <HeadingTag {...headingProps}>{body}</HeadingTag>;
    return <h3 {...headingProps}>{body}</h3>;
  }
}

export default CustomHeading;
